import React from "react";
import './pp.css'

const TermsConditions = () => {
  return (
    <div className="terms-container terms-page" style={{ padding: "2rem" }}>
       <h1>Terms and Conditions for Education Consultancy</h1>
      <p>Last Updated: {new Date().getFullYear()}</p>

      <p>
        Welcome to Nova EduBridge. By accessing or using our website or
        counselling services, you agree to comply with the following Terms and
        Conditions.
      </p>

      <h2>Services</h2>
      <p>
        We provide study abroad counselling, university admission support, visa
        guidance, scholarship assistance, and career counselling. Our
        recommendations are based on academic profiles and available
        opportunities; final admission or visa approval decisions depend solely
        on institutions and government bodies.
      </p>

      <h2>User Responsibilities</h2>
      <ul>
        <li>You must provide accurate and truthful information.</li>
        <li>
          You are responsible for submitting documents and payments on time.
        </li>
        <li>
          We are not responsible for delays caused by universities, embassies,
          or third-party institutions.
        </li>
      </ul>

      <h2>Payments & Refunds</h2>
      <ul>
        <li>Service fees (if applicable) once paid are generally non-refundable.</li>
        <li>
          Refunds are subject to internal policies and specific case-based
          approvals.
        </li>
        <li>
          Visa rejection is not grounds for service fee refund, as visa decision
          is beyond our control.
        </li>
      </ul>

      <h2>Limitation of Liability</h2>
      <p>
        While we provide guidance and support, we do not guarantee admission,
        scholarship, or visa approval. Decisions are made by respective
        authorities. We are not liable for financial or academic outcomes beyond
        advisory services.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        Website content, branding, images, and materials belong to Nova
        EduBridge and may not be copied without permission.
      </p>

      <h2>Contact Us</h2>
      <p>Email: info@novaedubridge.com</p>
      <p>Phone: +91 99020 43004</p>
      <p>
        Address: No.121, 1st Floor, Eshwar Plaza, 4th Main Road, 1st Phase, 1st
        Stage, Manjunatha Nagar, West of Cord Road, Bangalore - 560010.
      </p>

      <p>
        By continuing to use our website and services, you acknowledge that you
        have read and accepted these Terms & Conditions.
      </p>
    </div>
  );
};

export default TermsConditions;
